import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetWorkExperienceDetailResponse {
  workExperienceID: string;
  memberId: string;
  companyName: string;
  positionName: string;
  startDate: string;
  endDate: string;
  statement: string;
  consultantComments: string;
  usedTechnologies: string;
  reasonForLeave: string;
  isEnglish: boolean;
}

export interface UpdateWorkExperiencePayload {
  workExperienceID: string;
  memberId: string;
  companyName: string;
  positionName: string;
  startDate: string | null;
  endDate: string | null;
  statement: string;
  consultantComments: string;
  usedTechnologies: string;
  reasonForLeave: string;
  isEnglish: boolean;
}

export const getWorkExperienceDetail = async (
  workExperienceId: string
): Promise<GetWorkExperienceDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetWorkExperienceDetail/${workExperienceId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    }
  );

  const data = response.data?.data || response.data;

  const findField = (obj: any, fieldName: string) => {
    const key = Object.keys(obj).find(
      (k) => k.toLowerCase() === fieldName.toLowerCase()
    );
    return key ? obj[key] : undefined;
  };

  return {
    workExperienceID:
      findField(data, "workExperienceID") || findField(data, "workExperienceId"),
    memberId: findField(data, "memberId"),
    companyName: findField(data, "companyName"),
    positionName: findField(data, "positionName"),
    startDate: findField(data, "startDate"),
    endDate: findField(data, "endDate"),
    statement: findField(data, "statement"),
    consultantComments:
      findField(data, "consultantComments") || findField(data, "comment"),
    usedTechnologies:
      findField(data, "usedTechnologies") || findField(data, "techSkills"),
    reasonForLeave: findField(data, "reasonForLeave"),
    isEnglish: findField(data, "isEnglish"),
  };
};

export const updateWorkExperience = async (
  payload: UpdateWorkExperiencePayload
): Promise<any> => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${SERVICEURL}api/Candidates/UpdateWorkExperience`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        accept: "*/*",
      },
    }
  );
  return response.data;
};

export const deleteWorkExperience = async (
  workExperienceId: string
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(
    `${SERVICEURL}api/Candidates/DeleteWorkExperience/${workExperienceId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
